import React from 'react';
import './NavigationDock.module.css'; // Reuse glass styles if possible, or simple inline styles

const About = () => {
    return (
        <div className="tool-card" id="tool-card-about" style={{ maxWidth: '800px', margin: '0 auto' }}>
            <div className="card-header">
                <h2>About MasqIP Studio</h2>
                <p>Modern tools for IPv4 planning and visualization.</p>
            </div>

            <div className="column-content">
                <div className="field-group">
                    <h3 style={{ fontSize: '1.1rem', color: 'var(--md-on-surface)', marginBottom: '0.5rem' }}>Project Mission</h3>
                    <p style={{ lineHeight: '1.6', color: 'rgba(var(--md-sys-color-on-surface-rgb), 0.8)' }}>
                        MasqIP Studio simplifies network engineering tasks through a modern, spatial interface.
                        Whether you are sizing subnets for a new deployment or inspecting specific IP addresses
                        for classification, our tools are designed to provide immediate, visual feedback.
                    </p>
                </div>

                <div className="field-group">
                    <h3 style={{ fontSize: '1.1rem', color: 'var(--md-on-surface)', marginBottom: '0.5rem' }}>Features</h3>
                    <ul style={{ paddingLeft: '1.2rem', lineHeight: '1.6', color: 'rgba(var(--md-sys-color-on-surface-rgb), 0.8)' }}>
                        <li><strong>IPv4 Insight Panel:</strong> detailed classification, binary visualization, and range analysis.</li>
                        <li><strong>Hierarchical Calculator:</strong> VLSM planning with intuitive host-count sizing and automatic addressing.</li>
                        <li><strong>Spatial Navigation:</strong> Glassmorphism-inspired interface for a premium user experience.</li>
                        <li><strong>Local First:</strong> All calculations performed client-side for maximum privacy and speed.</li>
                    </ul>
                </div>

                <div className="field-group">
                    <h3 style={{ fontSize: '1.1rem', color: 'var(--md-on-surface)', marginBottom: '0.5rem' }}>Open Source</h3>
                    <p style={{ lineHeight: '1.6', color: 'rgba(var(--md-sys-color-on-surface-rgb), 0.8)' }}>
                        MasqIP is an open-source initiative. Contributions, bug reports, and feature requests are welcome.
                        Check out the authentic repository on GitHub to get involved.
                    </p>
                </div>

                <div className="field-group" style={{ marginTop: '1rem' }}>
                    <p style={{ fontSize: '0.8rem', color: 'rgba(var(--md-sys-color-on-surface-rgb), 0.5)' }}>
                        Version 1.0.0 &bull; Built with React
                    </p>
                </div>
            </div>
        </div>
    );
};

export default About;
